import * as React from 'react';

import { SVGProps } from './type';

const SvgComponent = (props: SVGProps) => {
  const { size = 24, color, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      {...rest}
    >
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
        d="M112 224a95.2 95.2 0 0 1-29-48"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
        d="M192 152c0 31.67 13.31 59 40 72H61a103.65 103.65 0 0 1-29-72c0-28.21 11.23-50.89 29.47-69.64a8 8 0 0 1 8.67-1.81l25.38 10.28a16 16 0 0 0 20.82-9l21-53.11c4.15-10 15.47-15.32 25.63-11.53a20 20 0 0 1 11.51 26.4l-21.35 53.1a16 16 0 0 0 8.93 20.76l24.94 9.84a8 8 0 0 1 5 7.43ZM43.93 105.57l148.87 59.55"
      />
    </svg>
  );
};

export default SvgComponent;
